declare const __BUILD_INFO__: { app: string; wave: string; builtAt: string };
export const buildInfo = __BUILD_INFO__;

export function installDebugHelper(extras: Record<string, unknown> = {}) {
  (window as any).bamoa = {
    version: buildInfo,
    debug() {
      const snap = {
        build: buildInfo,
        stele: {
          steleId: localStorage.getItem('bamoa_stele_id'),
          urlSteleId: new URLSearchParams(window.location.search).get('stele'),
        },
        url: window.location.href,
        userAgent: navigator.userAgent,
        ...extras,
      };
      console.log('%c━━━ Bamoa Debug Snapshot ━━━', 'font-weight:bold;color:#666');
      console.table(snap.build);
      console.table(snap.stele);
      console.log('Full snapshot:', snap);
      return snap;
    },
  };
  console.log(
    `%cBamoa ${buildInfo.app} · Welle ${buildInfo.wave} · ${buildInfo.builtAt}`,
    'color:#fff;background:#000;padding:2px 6px;border-radius:3px;font-weight:bold',
  );
}
